__turbopack_context__.v({
  "actionButton": "CheckoutOutOfStockBanner-module-scss-module__--1iyq__actionButton",
  "container": "CheckoutOutOfStockBanner-module-scss-module__--1iyq__container",
  "iconWrapper": "CheckoutOutOfStockBanner-module-scss-module__--1iyq__iconWrapper",
  "warningText": "CheckoutOutOfStockBanner-module-scss-module__--1iyq__warningText",
});
